import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import InventoryFuelTypesTable from './components/InventoryFuelTypesTable'
import { useSearchFuelTypesMutation } from '../../../services'
import { UspConfigurationCarFuelTypeViewResult } from '../../../models'
import AddEditFuelTypeModal from './components/AddEditFuelTypeModal'
import { Button, Card, Container, Grid } from '@mui/material'
import Iconify from '../../../components/iconify'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'

const SettingsInventoryFuelTypes = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchFuelType, { data, isLoading }] = useSearchFuelTypesMutation()
  const [carFuelTypeData, setCarFuelTypeData] = useState<UspConfigurationCarFuelTypeViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchFuelType({
      uspConfigurationCarFuelTypeView: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCarFuelTypeData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Fuel Types'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='Fuel Types' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <InventoryFuelTypesTable
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      handleOpenModal={handleOpenModal}
                      loading={isLoading}
                      data={carFuelTypeData}
                      setData={setCarFuelTypeData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditFuelTypeModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCarFuelTypeViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsInventoryFuelTypes
